import React from 'react';

import PropTypes from 'prop-types';

import * as flags from './flags';

import styles from './FlagIcon.scss';

function FlagIcon(props) {
    const {
        altText = '',
        className = '',
        code,
        square = false,
        ...otherProps
    } = props;

    let src = flags[code];

    if (square) {
        src = flags[`${code}Square`];
    }

    return (
        <img
            alt={altText}
            className={`${styles.baseIcon} ${className}`}
            src={src}
            {...otherProps}
        />
    );
}

FlagIcon.propTypes = {
    altText: PropTypes.string,
    className: PropTypes.string,
    code: PropTypes.string.isRequired,
    square: PropTypes.bool,
};

export default FlagIcon;
